import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import { connect } from 'react-redux';
import toLower from 'lodash/toLower';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { ExportOutlined } from '@ant-design/icons';
import FilterSearch from 'common/components/filter-search';
import {
  Row,
  Col,
  Button,
  Input,
  Popover,
  Select,
  DatePicker,
  Tooltip,
  Radio,
  AutoComplete,
  Form,
  Icon as LegacyIcon,
} from 'antd';
import {
  Tips as TipsIcon,
  IconReconciliationFunnel as ReconciliationFunnelIcon,
} from 'common/components/svgs';
import { formatDay, dayFormatType } from 'common/helpers/day';
import { orderReceivableStatus } from 'common/constants/reconciliation';
import * as actions from '~client/actions/reconciliation-list';
import FormDatePicker from '~pages/reconciliation/list/form-date-picker';
import { reconciliationOptions } from '~constants/bookings';
import { bookingJourneyType } from 'common/constants/booking';
import ReconciliationBookingStatusFilters from './booking-status-filters';
import { getTriggerPointOptions } from 'common/helpers/getTriggerPointOptions';
import { convertEmptyArrayToNull } from 'common/helpers/convertEmptyArrayToNull';

@connect(null, dispatch => ({
  searchCountryList: (params, onSuccess) => {
    dispatch(actions.searchCountryList(params, onSuccess));
  },
  searchCityList: (params, onSuccess) => {
    dispatch(actions.searchCityList(params, onSuccess));
  },
}))
class ReconciliationFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMore: true,
      showFilterModal: false,
      showLearnStatusBtn: false,
      landlordPropertyList: [],
      countryData: [],
      cityData: [],
      headerFilterDate: [],
      selectedPropertiesList: [],
      selectedSearchTerm: 'xbookingReferenceIds',
      propertyHasMore: true,
      propertyLoading: false,
      propertyPage: 1,
      propertyKeyword: '',
    };

    this.propertyPageSize = 10;

    this.dateFormat = 'YYYY-MM-DD';
    this.componentDateFormat = 'DD/MM/YYYY';
    this.otherStatus = [
      'NO_SHOW',
      'CANCELLED',
      'UNCLAIMABLE',
      'READY_TO_INVOICE',
      'INVOICED',
      'PAID',
    ];
    this.quickFilterBtn = ['ALL', 'READY_FOR_APPROVAL', 'PENDING_APPROVAL', 'APPROVED'];
    this.headerDateFilterKey = {
      [reconciliationOptions.BOOKING_COMPLETED]:
        'landlord.reconciliation_list.filter.header_filter_date.completed_at.label',
      [reconciliationOptions.STUDENT_CHECK_IN]:
        'landlord.reconciliation_list.filter.header_filter_date.final_move_in_date.label',
      [reconciliationOptions.STUDENT_CHECK_OUT]:
        'landlord.reconciliation_list.filter.header_filter_date.final_move_out_date.label',
    };

    this.statusList = this.quickFilterBtn.filter(btn => btn !== 'ALL').concat(this.otherStatus);
  }

  componentDidMount() {
    const { dateType } = this.props;
    const searchDate = queryString.parse(this.props.location.search);
    const filters = this.props.formatFilters(searchDate);
    this.setheaderFilterDate([filters[`${dateType}Start`], filters[`${dateType}End`]]);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters?.bookingJourney !== this.props.filters?.bookingJourney) {
      this.props.form.resetFields();
      this.setState({
        showMore: true,
        headerFilterDate: [],
        selectedPropertiesList: [],
        selectedSearchTerm: 'xbookingReferenceIds',
        propertyHasMore: true,
        propertyLoading: false,
        propertyPage: 1,
        propertyKeyword: '',
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dateType !== this.props.dateType) {
      const dateType = nextProps.dateType;
      const searchDate = queryString.parse(this.props.location.search);
      const filters = this.props.formatFilters(searchDate);
      this.setheaderFilterDate([filters[`${dateType}Start`], filters[`${dateType}End`]]);
    }
  }

  formatPropertiesListData = res => {
    if (res && res.viewer && res.viewer.properties && res.viewer.properties.edges) {
      const list = res.viewer.properties.edges.map(property => property.node);
      const newList = list.map(item => ({
        label: item.name,
        value: item.id,
      }));
      return newList;
    }

    return [];
  };

  formatDatePickerDefaultValue = (dateStart, dateEnd) => {
    if (dateStart || dateEnd) {
      return [dateStart ? moment(dateStart) : null, dateEnd ? moment(dateEnd) : null];
    }

    return null;
  };

  handleFilter = type => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values) {
          const { dateType, filters, bookingJourney } = this.props;

          let newValues = {
            bookingJourney,
          };

          let isMoreFilterTouched = false;

          if (type === 'searchTerm') {
            if (bookingJourney === bookingJourneyType.MANUAL) {
              newValues.completedAtStart = values.filterDate?.[0]
                ? formatDay(dayFormatType.FILTERPARAMS, values.filterDate[0])
                : null;
              newValues.completedAtEnd = values.filterDate?.[1]
                ? formatDay(dayFormatType.FILTERPARAMS, values.filterDate[1])
                : null;
              newValues.propertyIds = values?.propertyIds ?? null;
              newValues.landlordApplicationIds = values?.landlordApplicationIds ?? null;
              newValues.xbookingReferenceIds = values?.xbookingReferenceIds ?? null;
              newValues.invoiceNumber = values?.invoiceNumber ?? null;
            } else {
              newValues.citySlug = values?.citySlug ?? null;
              newValues.countrySlug = values?.countrySlug ?? null;
              newValues.propertyIds = values?.propertyIds ?? null;
              newValues.invoiceNumber = isEmpty(values?.invoiceNumber)
                ? null
                : values?.invoiceNumber;
              newValues.orderReferenceId = isEmpty(values?.orderReferenceId)
                ? null
                : values?.orderReferenceId;
              newValues.receivableStatus = values.receivableStatus ?? null;
              newValues.moveInDateStart = values.moveInDate[0]
                ? formatDay(dayFormatType.FILTERPARAMS, values.moveInDate[0])
                : null;
              newValues.moveInDateEnd = values.moveInDate[1]
                ? formatDay(dayFormatType.FILTERPARAMS, values.moveInDate[1])
                : null;
              newValues.moveOutDateStart = values.moveOutDate[0]
                ? formatDay(dayFormatType.FILTERPARAMS, values.moveOutDate[0])
                : null;
              newValues.moveOutDateEnd = values.moveOutDate[1]
                ? formatDay(dayFormatType.FILTERPARAMS, values.moveOutDate[1])
                : null;
              newValues.createdDateStart = values.createdDate?.[0]
                ? formatDay(dayFormatType.FILTERPARAMS, values.createdDate[0])
                : null;
              newValues.createdDateEnd = values.createdDate?.[1]
                ? formatDay(dayFormatType.FILTERPARAMS, values.createdDate[1])
                : null;
              newValues.completedDateStart = values.completedDate?.[0]
                ? formatDay(dayFormatType.FILTERPARAMS, values.completedDate[0])
                : null;
              newValues.completedDateEnd = values.completedDate?.[1]
                ? formatDay(dayFormatType.FILTERPARAMS, values.completedDate[1])
                : null;
              newValues.commissionTriggerPoint = convertEmptyArrayToNull(
                values?.commissionTriggerPoint,
              );
            }
          }

          if (type === 'moreFilter') {
            if (values.otherStatus) {
              newValues.landlordBookingStatuses = values.otherStatus;

              isMoreFilterTouched =
                newValues.landlordBookingStatuses !== filters.landlordBookingStatuses;
            }

            Object.values(reconciliationOptions).forEach(item => {
              if (dateType !== item) {
                newValues[`${item}Start`] =
                  values[item] && values[item][0]
                    ? moment(values[item][0]).format(this.dateFormat)
                    : null;
                newValues[`${item}End`] =
                  values[item] && values[item][1]
                    ? moment(values[item][1]).format(this.dateFormat)
                    : null;
              }

              if (!isMoreFilterTouched) {
                isMoreFilterTouched =
                  newValues[`${item}Start`] !== filters[`${item}Start`] ||
                  newValues[`${item}End`] !== filters[`${item}End`];
              }
            });
          }

          if (newValues || isMoreFilterTouched) {
            newValues.pageNumber = 1;
            this.props.setFilters({
              ...filters,
              ...newValues,
            });
          }
        }
      }
    });

    if (type === 'moreFilter') {
      this.setState({
        showFilterModal: !this.state.showFilterModal,
      });
    }
  };

  handleResetBtn = type => {
    if (type === 'searchTerm') {
      if (this.props.bookingJourney === bookingJourneyType.MANUAL) {
        this.props.form.resetFields([
          'filterDate',
          'propertyIds',
          'xbookingReferenceIds',
          'landlordApplicationIds',
          'partnerBookingId',
          'invoiceNumber',
        ]);
      } else {
        this.props.form.resetFields();
      }

      this.props.setFilters({
        bookingJourney: this.props.bookingJourney,
      });
    }

    if (type === 'moreFilter') {
      let moreFilterFields = [
        'otherStatus',
        reconciliationOptions.STUDENT_CHECK_IN,
        reconciliationOptions.STUDENT_CHECK_OUT,
        reconciliationOptions.BOOKING_COMPLETED,
      ];
      moreFilterFields = moreFilterFields.filter(item => item !== this.props.dateType);

      this.props.form.resetFields(moreFilterFields);
      const params = {};
      moreFilterFields.forEach(field => {
        params[field] = field === 'otherStatus' ? [] : null;
      });

      this.props.form.setFieldsValue(params);
      this.setState({ showFilterModal: true });
    }
  };

  handleQuickFilterBtn = status => {
    // const filters = { ...this.props.filters };
    this.props.form.setFieldsValue({ otherStatus: null });

    this.props.setFilters({
      ...this.props.filters,
      pageNumber: 1,
      landlordBookingStatuses: status === 'ALL' ? [] : [status],
    });
  };

  moreFilterContent = (t, getFieldDecorator) => (
    <div className="reconciliation-list__more-filter">
      {this.state.showFilterModal ? (
        <>
          <Form.Item
            colon={false}
            label={t('landlord.reconciliation_list.filter.other_status.label')}
          >
            {getFieldDecorator('otherStatus', {
              initialValue:
                this.props.filters.landlordBookingStatuses?.find(
                  item => this.otherStatus.indexOf(item) !== -1,
                ) || null,
            })(
              <Radio.Group className="reconciliation-list__more-filter__other-status-radio">
                <For of={this.otherStatus} each="item">
                  <Radio value={item} key={item}>
                    <Tooltip
                      title={t(
                        `landlord.reconciliation_list.table.status.${toLower(item)}.summary`,
                      )}
                      placement="topLeft"
                    >
                      {t(`landlord.reconciliation_list.table.status.${item.toLowerCase()}`)}
                    </Tooltip>
                  </Radio>
                </For>
              </Radio.Group>,
            )}
          </Form.Item>
          <For of={Object.keys(reconciliationOptions)} each="item">
            <If condition={this.props.dateType !== reconciliationOptions[item]}>
              <FormDatePicker
                t={t}
                key={item}
                dateType={reconciliationOptions[item]}
                keyType={item}
                form={this.props.form}
                initialValue={this.formatDatePickerDefaultValue(
                  this.props.filters[`${reconciliationOptions[item]}Start`],
                  this.props.filters[`${reconciliationOptions[item]}End`],
                )}
              />
            </If>
          </For>
          <div className="reconciliation-list__more-filter__btns">
            <button
              disabled={this.props.isLoading}
              onClick={() => {
                this.handleResetBtn('moreFilter');
              }}
              className="reconciliation-list__more-filter__clear-btn"
            >
              {t('landlord.reconciliation_list.filter.clear_all.btn')}
            </button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.props.isLoading}
              className="reconciliation-list__more-filter__apply-btn"
              onClick={() => {
                this.handleFilter('moreFilter');
              }}
            >
              {t('landlord.reconciliation_list.filter.apply.btn')}
            </Button>
          </div>
        </>
      ) : null}
    </div>
  );

  learnStatusContent = () => (
    <ul className="reconciliation-list__status-list">
      <For of={this.statusList} each="status">
        <li className="reconciliation-list__status-item">
          <label className="reconciliation-list__status-label">
            {this.props.t(`landlord.reconciliation_list.table.status.${toLower(status)}`)}
          </label>
          <p className="reconciliation-list__status-summary">
            {this.props.t(`landlord.reconciliation_list.table.status.${toLower(status)}.summary`)}
          </p>
        </li>
      </For>
    </ul>
  );

  handleMoreBtn = () => {
    this.setState({
      showFilterModal: !this.state.showFilterModal,
    });
  };

  handleLeartStatusBtnVisibleChange = isOpen => {
    this.setState(current => ({ ...current, showLearnStatusBtn: isOpen }));
  };

  hasOtherFilter = () => {
    const { dateType, filters } = this.props;
    let filterCount = 0;

    const otherStatus =
      filters.landlordBookingStatuses?.filter(item => this.otherStatus.indexOf(item) !== -1) || [];
    if (otherStatus && otherStatus.length > 0) {
      filterCount += 1;
    }

    Object.values(reconciliationOptions).forEach(item => {
      if (dateType !== item && (filters[`${item}Start`] || filters[`${item}End`])) {
        filterCount += 1;
      }
    });

    return filterCount;
  };

  handleHeaderDate = date => {
    const { dateType } = this.props;
    const params = [];

    params[`${dateType}Start`] = date && date[0] ? moment(date[0]).format('YYYY-MM-DD') : null;
    params[`${dateType}End`] = date && date[1] ? moment(date[1]).format('YYYY-MM-DD') : null;
    params.pageNumber = 1;

    this.setheaderFilterDate(date);
    this.props.pushState(params);
  };

  setheaderFilterDate = value => {
    this.setState({
      headerFilterDate: value || [],
    });
  };

  handleSelectSearchTerm = value => {
    this.setState({
      selectedSearchTerm: value,
    });
  };

  disabledDate = current => {
    const dates = this.state.headerFilterDate;

    if (!current) {
      return false;
    }

    if (current.diff(moment().subtract(1, 'years').startOf('years')) < 0) {
      return true;
    }

    if (!dates || dates.length === 0) {
      return false;
    }

    const tooLate = dates[0] && current.diff(dates[0], 'days') > 365;
    const tooEarly = dates[0] && moment(dates[0]).diff(current, 'days') > 365;
    return tooEarly || tooLate;
  };

  handleQueryCountry = value => {
    this.props.searchCountryList(value, res => {
      const countryData = res?.search?.edges ?? [];
      this.setState({
        countryData,
      });
    });
  };

  handleQueryCity = value => {
    this.props.searchCityList(value, res => {
      const cityData = res?.search?.edges ?? [];
      this.setState({
        cityData,
      });
    });
  };

  handleCalendarChange = e => {
    this.setheaderFilterDate(e);
  };

  handleToggleMoreBtn = () => {
    this.setState(prevState => ({
      showMore: !prevState.showMore,
    }));
  };

  handlePropertySearch = value => {
    if (value === '') {
      this.setState(prev => ({
        ...prev,
        landlordPropertyList: [],
        propertyHasMore: false,
        propertyKeyword: '',
        propertyPage: 1,
        propertyLoading: false,
      }));
      return;
    }

    if (value === this.state.propertyKeyword || this.state.propertyLoading || !value?.trim()) {
      return;
    }

    this.setState(prev => ({
      ...prev,
      propertyKeyword: value,
      propertyPage: 1,
      propertyLoading: true,
    }));

    this.props.getLandlordPropertyList(
      res => {
        const landlordPropertyList = this.formatPropertiesListData(res);
        const totalCount = res?.viewer?.properties?.totalCount ?? 0;
        const propertyHasMore = totalCount > this.propertyPageSize;
        this.setState({
          landlordPropertyList,
          propertyLoading: false,
          propertyHasMore,
        });
      },
      1,
      this.propertyPageSize,
      value,
      [this.props.bookingJourney],
    );
  };

  handlePropertyScrollEnd = () => {
    if (this.state.propertyLoading || !this.state.propertyHasMore) {
      return;
    }

    this.setState(prev => ({
      ...prev,
      propertyPage: prev.propertyPage + 1,
      propertyLoading: true,
    }));

    this.props.getLandlordPropertyList(
      res => {
        const landlordPropertyList = this.formatPropertiesListData(res);
        const totalCount = res?.viewer?.properties?.totalCount ?? 0;
        const newList = [...this.state.landlordPropertyList, ...landlordPropertyList];
        const propertyHasMore = totalCount > newList.length;
        this.setState({
          landlordPropertyList: newList,
          propertyLoading: false,
          propertyHasMore,
        });
      },
      this.state.propertyPage,
      this.propertyPageSize,
      this.state.propertyKeyword,
      [this.props.bookingJourney],
    );
  };

  handlePropertyChange = value => {
    const selectedPropertiesList = value.map(item => item.value);
    this.setState({
      selectedPropertiesList,
    });
  };

  render() {
    const { t, filters, bookingJourney, readyForApprovalCount, pendingCount, isLoading, total } =
      this.props;
    const { getFieldDecorator } = this.props.form;

    const { showMore, countryData, cityData, landlordPropertyList } = this.state;

    const bookingStatusList = this.quickFilterBtn.map(btn => ({
      label: t(`landlord.reconciliation_list.table.status.${btn.toLowerCase()}`),
      pointClassName:
        btn !== 'ALL'
          ? `reconciliation-list__id-filter__point reconciliation-list__id-filter__point--${btn
              .toLowerCase()
              .replace(/_/g, '-')}`
          : null,
      value: btn,
      count:
        btn === 'READY_FOR_APPROVAL'
          ? readyForApprovalCount
          : btn === 'PENDING_APPROVAL'
          ? pendingCount
          : null,
      popoverContent:
        btn !== 'ALL'
          ? this.props.t(`landlord.reconciliation_list.table.status.${toLower(btn)}.summary`)
          : null,
    }));

    return (
      <div>
        <div className="reconciliation-list__id-filter">
          <Form className="reconciliation-list__id-filter__form" layout="horizontal">
            <Row gutter={24}>
              <Choose>
                <When condition={bookingJourney === bookingJourneyType.MANUAL}>
                  <Col span={8}>
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t(
                        'landlord.reconciliation_list.filter.header_filter_date.completed_at.label',
                      )}
                    >
                      {getFieldDecorator('filterDate')(
                        <DatePicker.RangePicker
                          showArrow
                          style={{ width: '100%' }}
                          format={this.componentDateFormat}
                          onChange={this.handleHeaderDate}
                          value={this.formatDatePickerDefaultValue(
                            this.state.headerFilterDate[0],
                            this.state.headerFilterDate[1],
                          )}
                          disabledDate={this.disabledDate}
                          onCalendarChange={this.handleCalendarChange}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.property')}
                    >
                      {getFieldDecorator('propertyIds', {
                        initialValue: filters?.propertyIds ?? undefined,
                      })(
                        <FilterSearch
                          value={filters?.propertyIds ?? undefined}
                          isLoading={this.state.propertyLoading}
                          options={landlordPropertyList}
                          allowClear={true}
                          showSearch={true}
                          placeholder={t(
                            'landlord.reconciliation_list.filter.property.placeholder',
                          )}
                          onChange={this.handlePropertyChange}
                          onSearch={this.handlePropertySearch}
                          onScrollEnd={this.handlePropertyScrollEnd}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.booking_id')}
                    >
                      {getFieldDecorator('xbookingReferenceIds', {
                        initialValue: filters?.xbookingReferenceIds ?? null,
                      })(
                        <Input
                          placeholder={t(
                            'landlord.reconciliation_list.filter.booking_id.placeholder',
                          )}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.partner_booking_id')}
                    >
                      {getFieldDecorator('landlordApplicationIds', {
                        initialValue: filters?.landlordApplicationIds ?? null,
                      })(
                        <Input
                          placeholder={t('landlord.reconciliation_list.filter.partner_booking_id')}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.invoice_number')}
                    >
                      {getFieldDecorator('invoiceNumber', {
                        initialValue: filters?.invoiceNumber ?? null,
                      })(
                        <Input
                          placeholder={t(
                            'landlord.reconciliation_list.filter.invoice_number.placeholder',
                          )}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </When>
                <Otherwise>
                  <Col span={8}>
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.reconcil_status')}
                    >
                      {getFieldDecorator('receivableStatus', {
                        initialValue:
                          orderReceivableStatus?.[filters?.receivableStatus] ??
                          Object.keys(orderReceivableStatus),
                      })(
                        <Select
                          mode="multiple"
                          maxTagCount={1}
                          placeholder={t('landlord.reconciliation_list.filter.reconcil_status')}
                        >
                          <For of={Object.keys(orderReceivableStatus)} each="type">
                            <Select.Option value={type} key={type}>
                              {t(
                                `landlord.reconciliation_list.table.status.${type?.toLowerCase()}`,
                              )}
                            </Select.Option>
                          </For>
                        </Select>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.property')}
                    >
                      {getFieldDecorator('propertyIds', {
                        initialValue: filters?.propertyIds ?? undefined,
                      })(
                        <FilterSearch
                          value={filters?.propertyIds ?? undefined}
                          isLoading={this.state.propertyLoading}
                          options={landlordPropertyList}
                          allowClear={true}
                          showSearch={true}
                          placeholder={t(
                            'landlord.reconciliation_list.filter.property.placeholder',
                          )}
                          onChange={this.handlePropertyChange}
                          onSearch={this.handlePropertySearch}
                          onScrollEnd={this.handlePropertyScrollEnd}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.booking_number')}
                    >
                      {getFieldDecorator('orderReferenceId', {
                        initialValue: filters?.orderReferenceId ?? null,
                      })(
                        <Input
                          placeholder={t(
                            'landlord.reconciliation_list.filter.booking_number.placeholder',
                          )}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.destination_country')}
                    >
                      {getFieldDecorator('countrySlug', {
                        initialValue: filters?.countrySlug ?? null,
                      })(
                        <AutoComplete
                          onChange={this.handleQueryCountry}
                          placeholder={t(
                            'landlord.reconciliation_list.filter.destination_country.placeholder',
                          )}
                        >
                          <For of={countryData} each="item">
                            <AutoComplete.Option key={item?.node?.id} value={item?.node?.slug}>
                              {item?.node?.name}
                            </AutoComplete.Option>
                          </For>
                        </AutoComplete>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.destination_city')}
                    >
                      {getFieldDecorator('citySlug', {
                        initialValue: filters?.citySlug ?? null,
                      })(
                        <AutoComplete
                          onChange={this.handleQueryCity}
                          placeholder={t(
                            'landlord.reconciliation_list.filter.destination_city.placeholder',
                          )}
                        >
                          <For of={cityData} each="item">
                            <AutoComplete.Option key={item?.node?.slug} value={item?.node?.slug}>
                              {item?.node?.name}
                            </AutoComplete.Option>
                          </For>
                        </AutoComplete>,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.move_in_date')}
                    >
                      {getFieldDecorator('moveInDate', {
                        initialValue: [
                          filters?.moveInDateStart ? moment(filters?.moveInDateStart) : null,
                          filters?.moveInDateEnd ? moment(filters?.moveInDateEnd) : null,
                        ],
                      })(
                        <DatePicker.RangePicker
                          style={{ width: '100%' }}
                          format={this.dateFormat}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.move_out_date')}
                    >
                      {getFieldDecorator('moveOutDate', {
                        initialValue: [
                          filters?.moveOutDateStart ? moment(filters?.moveOutDate) : null,
                          filters?.moveOutDateEnd ? moment(filters?.moveOutDateEnd) : null,
                        ],
                      })(
                        <DatePicker.RangePicker
                          style={{ width: '100%' }}
                          format={this.dateFormat}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  {(this.props.bookingJourney === bookingJourneyType.SEMI_AUTOMATIC ||
                    this.props.bookingJourney === bookingJourneyType.LEAD_GENERATION) && (
                    <Col
                      span={8}
                      className={classNames({
                        'reconciliation__filter__col--hidden': showMore,
                      })}
                    >
                      <Form.Item
                        className="reconciliation__filter__item"
                        label={t('landlord.reconciliation_list.filter.create_date')}
                      >
                        {getFieldDecorator('createdDate', {
                          initialValue: [
                            filters?.createdDateStart ? moment(filters?.createdDateStart) : null,
                            filters?.createdDateEnd ? moment(filters?.createdDateEnd) : null,
                          ],
                        })(
                          <DatePicker.RangePicker
                            style={{ width: '100%' }}
                            format={this.dateFormat}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  {this.props.bookingJourney === bookingJourneyType.SEMI_AUTOMATIC && (
                    <Col
                      span={8}
                      className={classNames({
                        'reconciliation__filter__col--hidden': showMore,
                      })}
                    >
                      <Form.Item
                        className="reconciliation__filter__item"
                        label={t('landlord.reconciliation_list.filter.complete_date')}
                      >
                        {getFieldDecorator('completedDate', {
                          initialValue: [
                            filters?.completedDateStart
                              ? moment(filters?.completedDateStart)
                              : null,
                            filters?.completedDateEnd ? moment(filters?.completedDateEnd) : null,
                          ],
                        })(
                          <DatePicker.RangePicker
                            style={{ width: '100%' }}
                            format={this.dateFormat}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  <Col
                    span={8}
                    className={classNames({
                      'reconciliation__filter__col--hidden': showMore,
                    })}
                  >
                    <Form.Item
                      className="reconciliation__filter__item"
                      label={t('landlord.reconciliation_list.filter.invoice_number')}
                    >
                      {getFieldDecorator('invoiceNumber', {
                        initialValue: filters?.invoiceNumber ?? null,
                      })(
                        <Input
                          placeholder={t(
                            'landlord.reconciliation_list.filter.invoice_number.placeholder',
                          )}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  {this.props.bookingJourney === bookingJourneyType.LEAD_GENERATION && (
                    <Col
                      span={8}
                      className={classNames({
                        'reconciliation__filter__col--hidden': showMore,
                      })}
                    >
                      <Form.Item
                        className="reconciliation__filter__item"
                        label={t('landlord.reconciliation_list.filter.commission_trigger_point')}
                      >
                        {getFieldDecorator('commissionTriggerPoint', {
                          initialValue: filters?.commissionTriggerPoint ?? [],
                        })(
                          <Select
                            mode="single"
                            placeholder={t(
                              'landlord.reconciliation_list.filter.commission_trigger_point',
                            )}
                          >
                            <For of={getTriggerPointOptions(t)} each="type">
                              <Select.Option value={type.value} key={type.value}>
                                {type.text}
                              </Select.Option>
                            </For>
                          </Select>,
                        )}
                      </Form.Item>
                    </Col>
                  )}
                </Otherwise>
              </Choose>

              <Col
                span={8}
                className={classNames('reconciliation-list__id-filter-btns', {
                  'reconciliation-list__id-filter-btns--expanded': !showMore,
                })}
              >
                <Button onClick={() => this.handleResetBtn('searchTerm')}>
                  {t('landlord.reconciliation_list.filter.reset.btn')}
                </Button>
                <Button
                  type="primary"
                  style={{ margin: '0 12px' }}
                  htmlType="submit"
                  onClick={() => this.handleFilter('searchTerm')}
                >
                  {t('landlord.reconciliation_list.filter.search.btn')}
                </Button>
                <Button
                  type="link"
                  onClick={this.handleToggleMoreBtn}
                  className="reconciliation__filter__btn-more"
                >
                  {showMore
                    ? t('landlord.reconciliation_list.filter.expand.btn')
                    : t('landlord.reconciliation_list.filter.collapse.btn')}
                  <LegacyIcon
                    type={showMore ? 'down' : 'up'}
                    className="receive__filter__btn-icon"
                  />
                </Button>
              </Col>
            </Row>
          </Form>
        </div>

        <div className="reconciliation-list__filter">
          <Choose>
            <When condition={bookingJourney === bookingJourneyType.MANUAL}>
              <ReconciliationBookingStatusFilters
                bookingStatus={
                  filters.landlordBookingStatuses?.length === 0
                    ? 'ALL'
                    : filters.landlordBookingStatuses?.[0]
                }
                bookingStatusList={bookingStatusList}
                setBookingStatus={this.handleQuickFilterBtn}
              />

              <Popover
                content={this.moreFilterContent(t, getFieldDecorator)}
                trigger="click"
                placement="bottomLeft"
                visible={this.state.showFilterModal && !isLoading}
                onVisibleChange={bool =>
                  this.setState(currentState => ({ ...currentState, showFilterModal: bool }))
                }
              >
                <Button
                  onClick={this.handleMoreBtn}
                  className={classNames(
                    'reconciliation-list__filter-btn reconciliation-list__filter-btn--more',
                    {
                      'reconciliation-list__filter-btn--keppel': this.hasOtherFilter() > 0,
                    },
                  )}
                >
                  <If condition={this.hasOtherFilter() > 0}>
                    <div className="reconciliation-list__more-btn-count">
                      {this.hasOtherFilter()}
                    </div>
                  </If>
                  <ReconciliationFunnelIcon className="reconciliation-list__filter-btn-icon-funnel" />
                  {t('landlord.reconciliation_list.filter.more.btn')}

                  <LegacyIcon
                    type={this.state.showFilterModal ? 'up' : 'down'}
                    className="reconciliation-list__filter-btn-icon"
                  />
                </Button>
              </Popover>

              <Popover
                content={this.learnStatusContent()}
                onVisibleChange={this.handleLeartStatusBtnVisibleChange}
                trigger="click"
                placement="bottomLeft"
                autoAdjustOverflow={false}
              >
                <button className={classNames('reconciliation-list__learn-status')}>
                  <TipsIcon className="reconciliation-list__tips-icon" />
                  <span
                    className={classNames('reconciliation-list__learn-status__label', {
                      'reconciliation-list__learn-status__label--active':
                        this.state.showLearnStatusBtn,
                    })}
                  >
                    {t('landlord.reconciliation_list.table.status.tip.learn_booking_status')}
                  </span>
                </button>
              </Popover>
            </When>
            <Otherwise>
              <div className="reconciliation-list__total">
                <span className="reconciliation-list__total--text">
                  {t('landlord.reconciliation_list.total_count.text', {
                    total,
                  })}
                </span>
              </div>
            </Otherwise>
          </Choose>

          <div className="reconciliation-list__setting-btns">
            <Tooltip placement="top" title={t('landlord.reconciliation_list.export_report.tip')}>
              <Button
                id="export"
                type="link"
                disabled={isLoading}
                onClick={this.props.handleExport}
                className="reconciliation-list__setting-btn"
              >
                <ExportOutlined style={{ color: '#38B2A6' }} />
                <p className="reconciliation-list__export_text">Export</p>
              </Button>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

ReconciliationFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filters: PropTypes.object,
  form: PropTypes.object,
  pushState: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  getLandlordPropertyList: PropTypes.func,
  dateType: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  formatFilters: PropTypes.func,
  exportListLandlordOpportunities: PropTypes.func,
  isLoading: PropTypes.bool,
};

ReconciliationFilter.defaultProps = {
  t: () => {},
  filters: {},
  form: {},
  pushState: () => {},
  history: {
    push: () => {},
  },
  getLandlordPropertyList: () => {},
  dateType: '',
  location: {
    search: '',
  },
  formatFilters: () => {},
  exportListLandlordOpportunities: () => {},
  isLoading: false,
};

export default Form.create()(ReconciliationFilter);
